angular
  .module('components.planodiretor')
  .factory('PlanoDiretorRelatorioService', PlanoDiretorRelatorioService);

PlanoDiretorRelatorioService.$inject = ['$http', 'URL_REST'];

function PlanoDiretorRelatorioService($http, URL_REST) {

  function getRelatorio(vm) {
    return {
      content: [

        {
          style: 'unifamiliarTable',
          table: {
            widths: [200, 300],
            body: [
              [
                {
                  image: 'data:image/jpeg;base64,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',
                  width: 150,
                  border: [false]
                },
                {
                  text: 'PLANO DIRETOR ',
                  alignment: 'center',
                  fontSize: 15,
                  bold: true,
                  border: [false],
                  margin: [0, 100, 0, 0],
                },

              ],
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [55, 461],
            body: [
              [{text: 'Logradouro:', bold: true, border: [true, true, false, false]}, {
                text: '-',
                border: [false, true, true, false]
              },],
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [39, 180, 35, 78, 23, 28, 24, 55],
            body: [
              [
                {text: 'Número:', bold: true, border: [true, true, false, true]},
                {text: '-', border: [false, true, true, true]},
                {text: 'Quadra:', bold: true, border: [false, true, false, true]},
                {text: '-', border: [false, true, true, true]},
                {text: 'Lote:', bold: true, border: [false, true, false, true]},
                {text: '-', border: [false, true, true, true]},
                {text: 'Cep:', bold: true, border: [false, true, false, true]},
                {text: '-', border: [false, true, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [39, 180, 47, 135, 34, 45],
            body: [
              [
                {text: 'Bairro:', bold: true, border: [true, false, false, true]},
                {text: '-', border: [false, false, true, true]},
                {text: 'Município:', bold: true, border: [false, false, false, true]},
                {text: vm.informacaoVetor.ufcidade.nm_cid, border: [false, false, true, true]},
                {text: 'Estado:', bold: true, border: [false, false, false, true]},
                {text: '-', border: [false, false, true, true]},

              ]
            ]
          }
        },

        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'MACROZONEAMENTO', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: 'Macrozona Urbana', alignment: 'center', border: [true, false, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: '- ', border: [true, false, true, true]},
              ]
            ]
          }
        },

        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'ZONEAMENTO', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {
                  text: 'ZONA DE QUALIFICAÇÃO URBANA',
                  alignment: 'center',
                  border: [true, false, true, true]
                },
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: '- ', border: [true, false, true, true]},
              ]
            ]
          }
        },

        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'SISTEMA  VIÁRIO', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {
                  text: 'VIAS LOCAIS PRIMARIAS',
                  alignment: 'center',
                  border: [true, false, true, true]
                },
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: '- ', border: [true, false, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'GRAU DE INCONFORMIDADE', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {
                  text: 'GRAU DE INCONFORMIDADE1 \n GRAU DE INCONFORMIDADE2',
                  alignment: 'center',
                  border: [true, false, true, true]
                },
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: '-', border: [true, false, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'USO DO SOLO', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: 'UNIFAMILIAR', alignment: 'center', border: [true, false, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [525],
            body: [
              [
                {text: '-', border: [true, false, true, true]},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable2',
          table: {
            widths: [525],
            body: [
              [
                {text: 'PARÂMETROS URBANÍSTICOS', alignment: 'center'},
              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [150, 80, 277],
            body: [
              [
                {text: 'Coeficiente de Aproveitamento:', border: [true, false, false, true]},
                {text: '-', border: [false, false, true, true]},
                {text: 'Afastamento', alignment: 'center', border: [false, false, true, true]},


              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [150, 80, 100, 168],
            body: [
              [
                {text: 'Taxa de Ocupação:', border: [true, false, false, true]},
                {text: '-', border: [false, false, true, true]},
                {text: 'Frente:', border: [false, false, false, true]},
                {text: '-', alignment: 'right', border: [false, false, true, true]},


              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [150, 80, 100, 168],
            body: [
              [
                {text: 'Taxa de Permeabilidade:', border: [true, false, false, true]},
                {text: '-', border: [false, false, true, true]},
                {text: 'Lateral:', border: [false, false, false, true]},
                {text: '-', alignment: 'right', border: [false, false, true, true]},


              ]
            ]
          }
        },
        {
          style: 'unifamiliarTable',
          table: {
            widths: [239, 168, 100],
            body: [
              [
                {text: '', border: [true, false, false, true]},

                {text: 'Fundos:', border: [true, false, false, true]},
                {text: '-', alignment: 'right', border: [false, false, true, true]},


              ]
            ]
          }
        },


      ],
      styles: {
        unifamiliarTable: {
          fontSize: 10,
        },
        unifamiliarTable2: {
          fontSize: 10,
          margin: [0, 10, 0, 0],
        },

      },

    }
  }

  return {
    getRelatorio: getRelatorio
  };
}
